import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxButtonGroupComponent } from './phx-button-group.component';

@NgModule({
  declarations: [
    PhxButtonGroupComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    PhxButtonGroupComponent,
  ]
})
export class PhxButtonGroupModule { }
